// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatCard_card__q4sqy { padding: 10px; border-radius: 4px; background: #fff; }`, "",{"version":3,"sources":["webpack://./src/modules/Manager/FinStatisticV2/components/StatCard.module.css"],"names":[],"mappings":"AAAA,wBAAQ,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE","sourcesContent":[".card { padding: 10px; border-radius: 4px; background: #fff; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `StatCard_card__q4sqy`
};
export default ___CSS_LOADER_EXPORT___;
